import ActionType from 'actions/ActionType'

export default (state = 'all', action) => {
  switch (action.type) {
    case ActionType.Inbox.FILTER_CONVERSATIONS_LIST:
      return action.payload || 'all'
    // logic for read success from 'inboxfilter'
    case ActionType.Data.READ_SUCCESS:
      if (action?.entityType === 'inboxfilter') {
        return action.payload?.preference || state
      }
      return state
    default:
      return state
  }
}
